import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function BookingSuccess() {
  return (
    <div className="min-h-screen bg-[#FAFAF5] flex items-center justify-center px-6">
      <div className="max-w-lg text-center fade-slide" data-testid="booking-success">
        <div className="w-20 h-20 rounded-full bg-[#E8ECE1] text-[#6B7F3E] flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="w-10 h-10" strokeWidth={1.5} />
        </div>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold text-[#1A201A] tracking-tight mb-4">
          Vielen Dank!
        </h1>
        <p className="text-[#4A5D4E] leading-relaxed mb-8">
          Ihre Anfrage wurde erfolgreich übermittelt. Sie erhalten eine Bestätigung per E-Mail.
          Marvin Blessing meldet sich zeitnah bei Ihnen, um alle Details zu besprechen.
        </p>
        <Link
          to="/"
          data-testid="success-home-link"
          className="inline-flex items-center gap-2 bg-[#6B7F3E] hover:bg-[#5A6B34] text-white px-6 py-2.5 rounded-full text-sm font-medium transition-colors"
        >
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}
